<template>
  <div v-if="open">
    <spinner-component></spinner-component>
    <div>
      <router-component v-if="open"></router-component>
    </div>
  </div>
</template>

<script>
import RouterComponent from "@/components/RouterComponent.vue";
import SpinnerComponent from "@/components/SpinnerComponent.vue";

export default {
  name: "App",
  components: {
    RouterComponent,
    SpinnerComponent,
  },

  data: () => ({
    open: false,
  }),
  async beforeMount() {
    this.$i18n.locale = "en";

    this.checkLab();
    this.checkDevice();
    this.setRoute("lab");
    this.open = true;
  },
  methods: {
    checkLab() {
      let labName = window.location.pathname
        .split("/")
        .find((el) => ["AdiabaticLab", "LargeIndoor"].includes(el));

      if (!labName) {
        const urlParams = new URLSearchParams(window.location.search);
        labName = urlParams.get("lab") || 'AdiabaticLab';
      }

      const model = labName === "AdiabaticLab" ? "Chill_Lab" : "Indoor_Lab";

      this.$store.commit("setLab", model);
    },
    checkDevice() {
      const horizontal = Math.abs(window.orientation) === 90;

      const width = horizontal
        ? Math.max(screen.height, screen.width)
        : screen.width;

      const v_tabletBR = 1024;
      const v_mobileBR = 428;
      const h_tabletBR = 1366;
      const h_mobileBR = 926;

      let device;

      if (horizontal) {
        if (width <= h_mobileBR) {
          device = "mobile";
        } else if (width <= h_tabletBR) {
          device = "tablet";
        } else {
          device = "desktop";
        }
      } else {
        if (width <= v_mobileBR) {
          device = "mobile";
        } else if (width <= v_tabletBR) {
          device = "tablet";
        } else {
          device = "desktop";
        }
      }

      if (
        ["mobile", "tablet"].includes(device) &&
        process.env.NODE_ENV !== "development"
      ) {
        alert(this.$t("warningDeviceType"));
      }
    },
    setRoute(route) {
      this.$store.commit("setRoute", route);
    },
  },
};
</script>
<style lang="scss">
html {
  overflow-y: auto;
}
</style>
